import {RequestParam} from '../incase-domain/requestParams';
import {isRedirectParam} from './redirect';

const PLAYER_PARAMS = ['slideId'];

export type LinkErrorReason = 'missingParams' | 'unexpectedParams';

export interface LinkError {
    reason: LinkErrorReason;
    params?: string[];
}

export function getLinkError(declaredParams?: RequestParam[] | null, params: {[key: string]: string} = {}): LinkError | null {
    if (!declaredParams) return null;

    const declared = declaredParams.filter((param) => !isRedirectParam(param.key));
    const missing = declared.filter((param) => param.required && !params[param.key]?.trim()).map((param) => param.key);
    if (missing.length > 0) return {reason: 'missingParams', params: missing};

    const declaredKeys = new Set(declared.map((param) => param.key));
    const unexpected = Object.keys(params).filter((key) => !declaredKeys.has(key) && !PLAYER_PARAMS.includes(key));
    return unexpected.length > 0 ? {reason: 'unexpectedParams', params: unexpected} : null;
}
